export default "__VITE_ASSET__4sqGLaHp__"